import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { EventReservation } from './event-reservation.model';
import { EventService } from '../event/event.service';
import { EventReservationService } from './event-reservation.service';

import { StudentService } from '../student/student.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class EventReservationPopupService {
    private isOpen = false;

    constructor(
        private modalService: NgbModal,
        private eventService: EventService,
        private studentService: StudentService,
        private eventReservationService: EventReservationService,
        private router: Router
    ) { }

    open(component: Component, id?: number | any, studentId?: number | any, eventId?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.eventReservationService.find(id).subscribe(eventReservation => {
                this.eventReservationModalRef(component, eventReservation);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else if (eventId) {
            // We are creating a reservation for a specific event
            this.eventService.find(eventId).subscribe(event => {
                let eventReservation: EventReservation = new EventReservation();
                eventReservation.event = event;
                eventReservation.price = event.free ? 0 : event.standardUnitPrice;
                eventReservation.payedExternally = false;
                return this.eventReservationModalRef(component, eventReservation);
            });
        }
    }

    eventReservationModalRef(component: Component, eventReservation: EventReservation): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.eventReservation = eventReservation;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation-popup.service.ts